import * as React from 'react'
import { Connector, useAccount, useConnect } from 'wagmi'

import MetaMaskIcon from "/assets/images/wallet_icons/metamask.png"
import InjectedIcon from "/assets/images/wallet_icons/injected.png"
import WalletconnectIcon from "/assets/images/wallet_icons/walletconnect.png"
import SafeIcon from "/assets/images/wallet_icons/safe.png"
import PhantomIcon from "/assets/images/wallet_icons/phantom.png"
import { useApp, useModal } from '../../providers/providers'

export function WalletOptions() {
  const { connectors, connect } = useConnect()

  return connectors.map((connector) => (
    <WalletOption
      key={connector.uid}
      connector={connector}
      onClick={() => connect({ connector })}
    />
  ))
}

function WalletOption({
  connector,
  onClick,
}: {
  connector: Connector
  onClick: () => void
}) {
  const [ready, setReady] = React.useState(false)
  const { closeSelectWalletModal } = useModal()
  const { address, isConnected } = useAccount();

  React.useEffect(() => {
    ; (async () => {
      const provider = await connector.getProvider()
      setReady(!!provider)
    })()
  }, [connector])

  const handleWalletSelect = () => {
    onClick();
    setTimeout(() => {
      closeSelectWalletModal();
    }, 100);
  };

  const renderIcon = () => {
    switch (connector.name) {
      case 'MetaMask':
        return <img src={MetaMaskIcon} alt="MetaMask" className="w-6 h-6" />
      case 'WalletConnect':
        return <img src={WalletconnectIcon} alt="WalletConnect" className="rounded-full w-6 h-6" />
      case 'Injected':
        return <img src={InjectedIcon} alt="Injected" className="w-6 h-6" />
      case 'Safe':
        return <img src={SafeIcon} alt="Safe" className="w-6 h-6" />
      case 'Phantom':
        return <img src={PhantomIcon} alt="Phantom" className="w-6 h-6" />
      default:
        return <img src={WalletconnectIcon} alt="Default Wallet" className="w-6 h-6" />
    }
  }

  return (
    <button
      disabled={!ready}
      onClick={handleWalletSelect}
      className="flex flex-col justify-center items-center bg-[#192A35D9] hover:bg-[#204258] p-2 border-[#5AF4FF60] border-[1px] rounded-lg w-full max-w-[425px] h-full text-white transition-colors cursor-pointer"
    >
      <div className='flex flex-row justify-start items-center gap-4 w-[140px]'>
        {renderIcon()}
        <span>{connector.name}</span>
      </div>
    </button>
  )
}
